import { useSyncExternalStore } from 'react'

/**
 * Subscribe to a media query.
 *
 * `useSyncExternalStore` rather than `useState` + `useEffect`: the latter
 * renders once with a guessed value and then corrects it, which for a layout
 * switch means the drawer flashes on a desktop viewport before the rail takes
 * over. This reads the real value during render.
 *
 * `matchMedia` is absent in jsdom unless the test provides it; the getServer
 * snapshot and the guard both return false, which is the mobile layout -- the
 * narrower one, and so the safer default to be wrong about.
 */
export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (onChange) => {
      const mql = globalThis.matchMedia?.(query)
      if (!mql) return () => {}
      mql.addEventListener('change', onChange)
      return () => mql.removeEventListener('change', onChange)
    },
    () => globalThis.matchMedia?.(query).matches ?? false,
    () => false,
  )
}
